module.exports = __webpack_public_path__ + "img/serving_900.60bdb537.webp";